<template>
	<div class="form">
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">手机号：</div>
				<van-field center clearable v-model="formdata.phone" placeholder="请输入手机号" />
			</div>
			<div class="error" v-if="errors.phone">{{ errors.phone }}</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">获取验证码：</div>
				<van-field center clearable v-model="formdata.sms" placeholder="请输入验证码">
					  <template #button>
					    <van-button @click="sendSms" v-if="!isSms" size="small">发送验证码</van-button>
						<van-button class="btn-no" size="small" v-else>{{second}}s</van-button>
					  </template>
				</van-field>
			</div>
			<div class="error" v-if="errors.sms">{{ errors.sms }}</div>
		</div>
<!-- 		<div class="form-item">
			<div class="label">旧密码：</div>
			<van-field center clearable v-model="formdata.oldpass" placeholder="请输入旧密码(6-16位数字组合)" />
		</div> -->
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">新密码：</div>
				<van-field type="password" center clearable v-model="formdata.newpass" placeholder="请输入新密码(6-16位数字组合)" />
			</div>
			<div class="error" v-if="errors.newpass">{{ errors.newpass }}</div>
		</div>
		<div class="form-item">
			<div class="form-item-main">
				<div class="label">确认新密码：</div>
				<van-field type="password" center clearable v-model="formdata.renewpass" placeholder="请输入新密码(6-16位数字组合)" />
			</div>
			<div class="error" v-if="errors.renewpass">{{ errors.renewpass }}</div>
		</div>
		<van-button v-if="!login" class="submit" @click="submit" size="large">提交</van-button>
	</div>
</template>

<script>
export default {
	name: 'index',
	props: ["login"],
	data(){
		return {
			formdata:{
				phone:"",
				sms:"",
				// oldpass:"",
				newpass:"",
				renewpass:""
			},
			errors: {
				phone: '',
				sms: '',
				newpass: '',
				renewpass: '',
			},
			isSms:false,
			second:60,
		}
	},

	created(){

	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		async sendSms() {
			try {
				// 假设 accountCode 是用户输入的号码或账号
				const accountCode = this.formdata.phone;
				const response = await this.$api.sendSms({ accountCode });

				if (response.data.success) {
					this.$message.success("验证码已发送");
					this.isSms = true;
					this.startCountdown();
				} else {
					this.$message.error(response.data.message || "发送验证码失败");
				}
			} catch (error) {
				this.$message.error("发送失败，请重试");
			}
		},
		startCountdown() {
			this.second = 60;
			const countdown = setInterval(() => {
				if (this.second > 0) {
					this.second -= 1;
				} else {
					this.isSms = false;
					clearInterval(countdown);
				}
			}, 1000);
		},
		validateForm() {
			// 重置错误信息
			this.errors = {
				phone: '',
				sms: '',
				password: '',
				confirmPassword: '',
			};

			let valid = true;

			// 手机号校验：11位数字，符合中国手机号格式
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!this.formdata.phone) {
				this.errors.phone = '手机号不能为空';
				valid = false;
			} else if (!phoneRegex.test(this.formdata.phone)) {
				this.errors.phone = '手机号格式不正确';
				valid = false;
			}

			// 验证码校验：6位数字
			const codeRegex = /^\d{4}$/;
			if (!this.formdata.sms) {
				this.errors.sms = '验证码不能为空';
				valid = false;
			} else if (!codeRegex.test(this.formdata.sms)) {
				this.errors.sms = '验证码必须是4位数字';
				valid = false;
			}

			// 密码校验：6-16位字符
			if (!this.formdata.newpass) {
				this.errors.newpass = '密码不能为空';
				valid = false;
			} else if (this.formdata.newpass.length < 6 || this.formdata.newpass.length > 16) {
				this.errors.newpass = '密码必须是6到16位字符';
				valid = false;
			}

			// 确认密码校验：与密码一致
			if (!this.formdata.renewpass) {
				this.errors.renewpass = '请确认密码';
				valid = false;
			} else if (this.formdata.renewpass !== this.formdata.newpass) {
				this.errors.renewpass = '两次密码输入不一致';
				valid = false;
			}

			if (valid) {
				return true
			} else {
				return false
			}
		},
		async submit() {//修改密码提交
			if(!this.validateForm()){
				return;
			}
			const data = this.formdata; // 访问子组件的数据
			console.log(data);
			let jsondata = {
				accountCode: data.phone,
				password: data.newpass,
				verifyCode: data.sms
			};
			const res = await this.$api.updatePassword(jsondata);
			if (res.data.success) {
				this.$message.success("修改成功")
				localStorage.removeItem("userInfo");
				localStorage.removeItem("userCode");
				this.$router.replace({ path: '/' });
			}else{
				this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
	.form{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
		.form-item{
			margin-bottom: 1rem;
			.form-item-main{
				display: flex;
				align-items: center;
			}
			.label{
				width: 8rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				color: #282D30;
				line-height: 1.41rem;
				text-align: right;
				margin-right: 1.5rem;
			}
			.van-cell{
				width: 28.6rem;
				height: 3.1rem;
				border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
				border: 0.05rem solid #E0E0E0;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.2rem;
				line-height: 2.1rem;
			}
			.van-button{
				width: 7rem;
				height: 1.85rem;
				background: rgb(100, 45, 113);
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1rem;
				color: #FFFFFF;
				line-height: 1.85rem;
				text-align: center;
			}
			::v-deep .van-field__button{
				display: flex;
			}
		}
		.submit{
			width: 8.4rem;
			height: 2.9rem;
			background: rgb(100, 45, 113);
			border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.4rem;
			color: #FFFFFF;
			line-height: 2.9rem;
			text-align: center;
			margin-top: 1rem;
		}
	}
	.error {
	  color: red;
	  font-size: 1.2rem;
		width: 18.5rem;
		margin-left: 9.5rem;
		margin-top: 0.5rem;
	}
	.btn-no{
		background-color: #ccc;
		color: #000;
	}
</style>